var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.chartLoading),expression:"chartLoading"}],staticClass:"chart-component"},[_c('div',{staticClass:"container",class:_vm.byDashboard ? 'by-dashboard' : ''},[_c('div',{staticClass:"num-text single-ellipsis"},[_vm._v(_vm._s(_vm.count.toLocaleString()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }